import React, { useEffect, useState } from 'react';
import { InputReact } from 'common/components/input';
import { InputSize } from 'common/components/input/types';
import { useTranslation } from 'common/i18n/hooks';
import styles from './prompter.module.styl';
export function Prompter(props: {
  loading: boolean;
  responseText: string;
  onSubmit: (prompt: string) => void;
}) {
  const {
    t
  } = useTranslation();
  const [value, setValue] = useState("");
  useEffect(() => {
    if (!props.loading) {
      setValue("");
    }
  }, [props.loading]);
  return <div className={styles.wrapper} data-sentry-component="Prompter" data-sentry-source-file="prompter.tsx">
      <div className={styles.container}>
        <InputReact className={styles.input} size={InputSize.Medium} icon={props.loading ? "spinner" : "spark"} value={value} disabled={props.loading} placeholder={t("query-builder.buckets.prompter-placeholder")} autoFocus onInput={ev => setValue(ev.currentTarget.value)} onKeydown={ev => {
        if (ev.key === "Enter") {
          ev.stopPropagation();
          props.onSubmit(value);
        }
      }} data-sentry-element="InputReact" data-sentry-source-file="prompter.tsx" />
        {!!props.responseText && <p className={styles.response}>{props.responseText}</p>}
      </div>
    </div>;
}